// @flow

import type { Action } from "redux-action";
import { beginRequest, completeRequest } from "@store/utils";

import type { ServiceSettingsState } from "./types";

const startRequest = beginRequest(["requestsInProgress"]);

const finishRequest = completeRequest(["requestsInProgress"]);

// Get Service Settings

export const onUpdateServiceSettings = (state: ServiceSettingsState) => () => startRequest(state);
export const onUpdateServiceSettingsSuccess = (state: ServiceSettingsState) => () =>
  finishRequest(state);
export const onUpdateServiceSettingsError = (state: ServiceSettingsState) => () =>
  finishRequest(state);

export const onServiceSettings = (state: ServiceSettingsState) => () => startRequest(state);

export const onServiceSettingsSuccess = (state: ServiceSettingsState) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  settings: payload,
});

export const onServiceSettingsError = (state: ServiceSettingsState) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

// Get Service Settings Schema

export const onGetServiceSettingsSchema = (state: ServiceSettingsState) => () =>
  startRequest(state);

export const onGetServiceSettingsSchemaSuccess = (state: ServiceSettingsState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  schema: payload,
});

export const onGetServiceSettingsSchemaError = (state: ServiceSettingsState) => ({
  payload,
}: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

// Edit

export const onSetEditedServiceSettings = (state: ServiceSettingsState) => ({
  payload,
}: Object) => ({
  ...state,
  edits: payload,
});

export const onClearEditedServiceSettings = (state: ServiceSettingsState) => () => ({
  ...state,
  edits: null,
});

// Modals

export type ShowEditModalRequest = $Exact<{
  show: boolean,
  step?: number,
}>;

export const onSetShowEditModal = (state: ServiceSettingsState) => ({
  payload,
}: Action<ShowEditModalRequest>) => {
  if (!payload) {
    return state;
  }

  return {
    ...state,
    modals: {
      ...state.modals,
      showEditModal: payload.show,
      modalStep: payload.step || state.modals.modalStep,
    },
  };
};

export const onSetShowSubmitModal = (state: ServiceSettingsState) => ({ payload }: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showSubmitModal: payload,
  },
});
